////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'
import convertHexToRGBA from '../../../helpers/HexToRgba'

//////STYLED//////
const StatusWrapper = styled.div`
	max-height: auto;
	max-width: auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
`
const DistributionGroupRepositoryStatusWrapper = styled.div`
	text-align: center;
	background-color: ${(props) => convertHexToRGBA(props.colorCode, 0.2)};
	color: ${(props) => props.colorCode};
	line-height: 32px;
	font-weight: bold;
	width: fit-content;
	padding: 0 10px;
	border-radius: 15px;
	margin: 0 auto;
	font-weight: bold;
`
//////STYLED//////

const KioskImplantationStatus = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<StatusWrapper>
			<DistributionGroupRepositoryStatusWrapper colorCode={props.row.lockerState.color}>
				{translations[props.row.lockerState.translationKey]}
			</DistributionGroupRepositoryStatusWrapper>
		</StatusWrapper>
	)
}

KioskImplantationStatus.propTypes = {}

KioskImplantationStatus.defaultPropTypes = {}

export default KioskImplantationStatus
